module.exports = __webpack_public_path__ + "img/data.9526816e.png";